<script>
import PinboardStatusButton from '@/components/PinboardStatusButton.vue'

export default {
  name: 'LocationHero',
  components: { PinboardStatusButton },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    location() {
      return this.$store.getters.locationById(this.id)
    },
    count() {
      if (!this.location) {
        return 0
      }

      return this.location.runners.total.total
    }
  }
}
</script>

<template>
  <section class="card">
    <template v-if="location">
      <header slot="header">
        <img
          v-if="location.image"
          class="img-fluid w-100 location-cover rounded-top"
          v-bind="{ src: location.image, alt: location.title }"
        >
      </header>

      <div class="text-center font-lg text-uppercase p-4 d-flex flex-column">
        <div class="d-flex justify-content-between align-items-center">
          <h1>{{ location.title }}</h1>
          <PinboardStatusButton
            v-bind="{ type: 'location', id: location.id, icon:true }"
          />
        </div>
        <div class="d-flex mt-3 text-condensed font-weight-bold">
          <span class="badge badge-outlined p-2">
            <flag
              v-if="location"
              :iso="location.iso2"
              :squared="false"
              class="mr-1"
            />
            {{ location.ioc }}
          </span>

          <span class="badge badge-outlined p-2 mx-2">
            {{ $tc('location.participants.count', count, [count]) }}
          </span>
        </div>
      </div>
    </template>
  </section>
</template>

<style scoped>
.location-cover {
  max-height: 280px;
  object-fit: cover
}
</style>
